/* eslint-disable max-lines-per-function */
import { Button } from '@/components';
import { FieldError } from '@/components/ui/field';
import { TextAreaFormField } from '@/domain/termine/features/UpdateTermin/Desktop/components/FormFields/TextAreaFormField';
import { TimeInputFormField } from '@/domain/termine/features/UpdateTermin/Desktop/components/FormFields/TimeInputFormField';
import { CalendarSelectFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields';
import { ColorPickerFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/ColorPickerFormField';
import { DatePickerFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/DatePickerFormField';
import { ImageFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/ImageFormField';
import { InputFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/InputFormField';
import { RepetitionIntervalFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/RepetitionIntervalFormField';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function UpdateTermineFormContent({
  form,
  isMobile,
}: UpdateTermineFormProps) {
  const { t } = useTranslation();
  const [showSpecials, setShowSpecials] = useState(false);

  return (
    <div className="flex flex-col gap-4 p-6 pb-24">
      <span className="font-normal text-neutrals-700 text-xs">
        {t('domain.termine.sheet.pflichtfelder')}
      </span>
      <div className="flex flex-col flex-1 gap-4">
        <ImageFormField form={form} />
        <div className="flex flex-col gap-4 flex-1">
          <div className="flex gap-4 items-start">
            <InputFormField form={form} />
            <ColorPickerFormField form={form} isMobile={isMobile} />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <DatePickerFormField name="datum" form={form} />
            <div className="flex flex-col">
              <div className="flex gap-4">
                <TimeInputFormField name="beginn" form={form} />
                <TimeInputFormField name="ende" form={form} />
              </div>
              <form.Subscribe selector={(state) => [state.fieldMeta]}>
                {([fieldMeta]) => {
                  const timeErrors =
                    fieldMeta.beginn?.errors ?? fieldMeta.ende?.errors;
                  return <FieldError errors={timeErrors} />;
                }}
              </form.Subscribe>
            </div>
          </div>
          <div className="flex flex-col gap-4 w-full">
            <RepetitionIntervalFormField form={form} isMobile={isMobile} />
          </div>
          <CalendarSelectFormField form={form} isMobile={isMobile} />
          <TextAreaFormField form={form} name="beschreibung" />
          {!showSpecials && (
            <Button
              type="button"
              variant="ghost-primary"
              className="self-start w-auto"
              onClick={() => setShowSpecials(true)}>
              <span className="text-sm">
                {t('domain.termine.addAdditionalInformation')}
              </span>
            </Button>
          )}
          {showSpecials && <TextAreaFormField form={form} name="specials" />}
        </div>
      </div>
    </div>
  );
}
